<template>
  <div
    class="tw:md:w-[590px] tw:lg:w-[916px] tw:whitespace-normal tw:text-left tw:shadow-[2px_2px_4px_0px_rgba(0,0,0,0.25)] tw:bg-white tw:rounded-xl tw:border tw:border-gray-300"
  >
    <div class="tw:flex tw:items-center tw:gap-4">
      <div
        class="tw:bg-decorative-orange tw:w-[40px] tw:h-[40px] tw:flex tw:justify-center tw:items-center tw:rounded-full tw:shrink-0 tw:ml-6 tw:my-7"
      >
        <img :src="item.icon" :alt="$t(item.title)" class="tw:w-[24px] tw:h-[24px]" />
      </div>
      <div class="tw:grow-1 tw:py-6">
        <h2 class="tw:font-bold tw:text-xl tw:leading-4 tw:mb-1">{{ $t(item.title) }}</h2>
        <p v-if="item.subtitle && !isExpanded">{{ $t(item.subtitle) }}</p>
      </div>
      <button
        class="tw:pr-8 tw:pl-10 tw:cursor-pointer tw:shrink-0 tw:grid tw:place-items-center tw:self-stretch"
        @click="emit('onCardClick', { itemId: item.id })"
      >
        <ChevronDownLanding :class="{ 'tw:rotate-180': isExpanded }" />
      </button>
    </div>
    <div
      class="tw:grid tw:transition-all tw:duration-300 tw:ease-in-out tw:px-6"
      :class="isExpanded ? 'tw:grid-rows-[1fr]' : 'tw:grid-rows-[0fr]'"
    >
      <div class="tw:overflow-hidden">
        <ul class="tw:list-disc tw:ml-7 tw:flex tw:flex-col tw:gap-2">
          <li v-for="benefit in item.benefits" :key="benefit" v-html="$t(benefit)"></li>
        </ul>
        <video
          ref="videoRef"
          muted
          loop
          width="1340"
          height="402"
          :src="item.vid"
          @click="togglePlay"
          class="tw:object-contain tw:cursor-pointer tw:h-[162px] tw:lg:h-[258px] tw:mt-8 tw:mb-7"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'

import ChevronDownLanding from '@/components/icons/ChevronDownLanding.svg?component'

const emit = defineEmits(['onCardClick'])

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
  isExpanded: {
    type: Boolean,
    default: false,
  },
})

const videoRef = ref(null)

const togglePlay = () => {
  if (!videoRef.value) return
  videoRef.value.paused ? videoRef.value.play() : videoRef.value.pause()
}

watch(
  () => props.isExpanded,
  newIsExpandedValue => {
    if (!videoRef.value) return
    newIsExpandedValue ? videoRef.value.play() : videoRef.value.pause()
  }
)
</script>
